import * as React from "react";
import { Grid } from "semantic-ui-react";

import { ADMIN_ROLES, Authorize } from "../../auth";
import { AdminStatistics, getLastUpdatedToDisplay } from "../models";

import { StatisticBadge } from "./StatisticBadge";

import { Link } from "redux-little-router";

import "../styles/statistics.scss";

interface Props {
    statistics: AdminStatistics;
}

export const AdminStatisticsGridOld = (props: Props) => (
    <Grid textAlign="center">
        <h2 className="statistics-padding">System Status</h2>
        <Grid.Row columns={5}>
            <Grid.Column>
                <Link href="/triages">
                    <StatisticBadge label="Outstanding Triage" value={props.statistics?.outstandingTriageCount} />
                </Link>
            </Grid.Column>
            <Grid.Column>
                <Link href="/partiallyMatchedEmployees">
                    <StatisticBadge label="Employees to Match" value={props.statistics?.employeesToMatchCount} />
                </Link>
            </Grid.Column>
            <Grid.Column>
                <Link
                    // eslint-disable-next-line max-len
                    href={"/actionableTasks?taskTypes=WriteReportReferralTask&taskTypes=WritePhysiotherapyReportTask&taskTypes=AmendReportTask&taskTypes=AmendPhysiotherapyReportTask"}
                >
                    <StatisticBadge label="Reports to Write" value={props.statistics?.reportsToWriteCount} />
                </Link>
            </Grid.Column>
            <Authorize roles={[ADMIN_ROLES.QA_AUDITOR]}>
                <Grid.Column>
                    <Link href="/qaAuditQueue">
                        <StatisticBadge label="Reports to QA" value={props.statistics?.reportsToQACount} />
                    </Link>
                </Grid.Column>
            </Authorize>
            <Grid.Column>
                <Link
                    href={"/actionableTasks?taskTypes=CaseConversationTask"}
                >
                    <StatisticBadge label="Case Conversations" value={props.statistics?.caseConversationCount} />
                </Link>
            </Grid.Column>
        </Grid.Row>
        <Grid.Row>
            <Grid.Column textAlign="right">
                Last Updated: {getLastUpdatedToDisplay(props.statistics?.lastUpdated)}
            </Grid.Column>
        </Grid.Row>
    </Grid>
);
